<template>
    <nav class="DefaultNav" :class="{'spaceBetween': spaceBetween}">
        <ul v-if="enableSubnav" class="DefaultNav__list">
            <DefaultNavItem
                v-for="item in nav"
                :key="item.id"
                :item="item"
            />
        </ul>
        <ul v-else class="DefaultNav__list">
            <slot />
            <li
                v-for="item in nav"
                :key="item.id"
                class="DefaultNav__item"
                :class="{'is-parent' : item.heading == 'Destinations' || item.heading == 'Do & See', 'is-active' : isCurrent(item.uri) }"
                @mouseover="handleFlyoutState(item)"
            >
                <a
                    :href="item.url"
                >
                    {{ item.heading || item.title }}

                    <small
                        v-if="summary && item.children.length"
                    >
                        <span v-for="(child, index) in item.children.slice(0, 3)" :key="child.id">{{ child.title }}<span v-if="index !== 3">, </span>
                        </span>
                        and more
                    </small>

                </a>

                <figure
                    v-if="item.heading === 'Destinations' || item.heading === 'Do & See'"
                    class="hide--reciteme-and-up"
                    @click="toggleSubnav(item.heading)"
                >
                    <BaseIcon
                        icon="chevron-right"
                    />
                </figure>
            </li>
        </ul>
        <transition name="slide">
            <DefaultNav
                v-if="subnavActive && subnavType === 'Destinations'"
                :nav="subnav"
                summary
            >
                <li
                    class="DefaultNav__item DefaultNav__item--close text--blue is-parent"
                    @click="toggleSubnav"
                >
                    <a>
                        <BaseIcon
                            icon="chevron-right"
                        />
                        Back
                    </a>
                </li>
            </DefaultNav>
            <DefaultNav
                v-if="subnavActive && subnavType === 'Do & See'"
                :nav="doSee"
                summary
            >
                <li
                    class="DefaultNav__item DefaultNav__item--close text--blue is-parent"
                    @click="toggleSubnav"
                >
                    <a>
                        <BaseIcon
                            icon="chevron-right"
                        />
                        Back
                    </a>
                </li>
            </DefaultNav>
        </transition>
    </nav>
</template>
<script>
import { EventBus } from '../scripts/event-bus'
export default {
    name: 'DefaultNav',
    props: {
        nav: {
            type: Array,
            default: null,
        },
        subnav: {
            type: Array,
            default: null,
        },
        summary: {
            type: Boolean,
            default: false,
        },
        navIsActive: {
            type: Boolean,
            default: false,
        },
        spaceBetween: {
            type: Boolean,
            default: false
        },
        doSee: {
            type: Array,
            default: null
        },
        enableSubnav: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            flyoutActive: false,
            subnavActive: false,
            subnavType: null
        }
    },
    watch: {
        navIsActive() {
            if (this.navIsActive === false) {
                this.subnavActive = false
            }
        }
    },
    methods: {
        toggleSubnav(type = null) {
            this.subnavType = type
            this.subnavActive = !this.subnavActive
        },
        handleFlyoutState(item) {
            if (item.heading === 'Destinations' || item.heading === 'Do & See') {
                EventBus.$emit('flyoutType', item.heading)
                document.body.classList.add('flyout-is-active')
            }
        },
        isCurrent(slug) {
            const uri = `/${slug}`
            return window.location.pathname === uri ? true : false
        },
        getChildren(item) {
            return item.children.filter((child) => child.hideFromNav === false);
        }
    }
}
</script>
<style lang="scss">
    .DefaultNav {
        position: relative;

        @include media-query(reciteme-and-up) {
            text-align: center;
            top: 0;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 3;
            pointer-events: none;
        }

        .DefaultNav {
            z-index: 4;
            @include media-query(reciteme-and-up) {
                display: none;
            }
        }
    }

    .DefaultNav__list {
        @include media-query(reciteme) {
            left: 0;
            position: absolute;
            background: #F5F5F5;
            top: -110vh;
            transition: all 600ms cubic-bezier(0.23, 1, 0.32, 1);
            height: 100vh;
            overflow: auto;
            width: 100vw;
            z-index: 1;

            body.nav-is-active & {
               top: 0;
               padding-bottom: getSpacing('large');
            }
        }

        @include media-query(reciteme-and-up) {
            pointer-events: all;
        }

        + .BaseIcon {
            font-size: 1.35rem;
        }

        @include media-query(lap) {
            body.nav-is-active & {
               top: 0;
               z-index: 2;
            }
        }

        .DefaultNav.spaceBetween & {
            @include media-query('(min-width: 1023px) and (max-width: 1216px)') {
                display: flex;
                justify-content: space-between;
                width: 100%;
            }
        }
    }

    .DefaultNav__item {
        position: relative;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;

        @include media-query(reciteme-and-up) {
            display: inline-block;
            font-size: 0.75rem;
            margin: 0 getSpacing('base');
            transition: all ease-out 0.325s;

            &:hover, &.is-active {
                color: $action-color;
            }


            .BaseIcon {
                display: none;
            }
        }

        @include media-query(reciteme) {
            display: block;
            background: #F5F5F5;
            border-bottom: 1px solid $border-color;

            a {
                display: block;
                padding: getSpacing('spacer');

                small {
                    text-transform: none;
                    padding-top: 0.5rem;
                    letter-spacing: 0;
                    font-weight: 500;
                    font-size: 16px;
                    display: block;
                }
            }

            figure {
                display: flex;
                cursor: pointer;
                align-items: center;
                justify-content: center;
                width: 68px;
            }

            .BaseIcon {
                font-size: 0.8rem;
                margin-right: 0.35rem;
                color: $action-color;
            }

            &.is-active {
                color: $action-color;
            }
        }

        &.is-parent {
            @include media-query(reciteme) {
                display: flex;
                justify-content: space-between;
            }
        }
    }

    .DefaultNav__item--close {
        @include media-query(reciteme) {
            cursor: pointer;

            .BaseIcon {
                transform: rotate(180deg);
                margin-right: 1rem;
            }
        }
    }

    .DefaultNav.spaceBetween .DefaultNav__item,
    .DefaultNav.spaceBetween .DefaultNavItem {
        @include media-query('(min-width: 1023px) and (max-width: 1216px)') {
            margin: 0;
            display: block;
        }
    }

    .slide-leave-active,
    .slide-enter-active {
        transition: 0.765s;
    }
    .slide-enter {
        transform: translate(100%, 0);
    }
    .slide-leave-to {
        transform: translate(0, 100%);
    }
</style>
